var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressdone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4993,
    cy: 20.5003,
    r: 17.0833,
    fill: "#468C11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.959 18.7917L18.3652 25.625L29.0423 15.375",
    stroke: "white",
    strokeWidth: 2.5625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressdone);
export default __webpack_public_path__ + "static/media/progressdone.c340a400075f84d01fd9e5651373023a.svg";
export { ForwardRef as ReactComponent };